var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icone_instagram_negativo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.04,
    height: 35.04,
    viewBox: "0 0 35.04 35.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_235",
    "data-name": "Caminho 235",
    d: "M25.538,21.919A3.619,3.619,0,1,1,21.919,18.3,3.619,3.619,0,0,1,25.538,21.919Z",
    transform: "translate(-4.399 -4.399)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_236",
    "data-name": "Caminho 236",
    d: "M25.249,12.6h-8.8A3.949,3.949,0,0,0,12.5,16.548v8.719a3.949,3.949,0,0,0,3.948,3.948h8.8A3.949,3.949,0,0,0,29.2,25.267v-8.8A3.932,3.932,0,0,0,25.249,12.6ZM20.89,26.089a5.264,5.264,0,1,1,5.264-5.264A5.248,5.248,0,0,1,20.89,26.089Zm5.429-9.87a.823.823,0,1,1,.823-.823A.824.824,0,0,1,26.319,16.219Z",
    transform: "translate(-3.37 -3.388)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_237",
    "data-name": "Caminho 237",
    d: "M18.92,1.4A17.52,17.52,0,1,0,36.44,18.92,17.534,17.534,0,0,0,18.92,1.4Zm9.87,21.879a5.511,5.511,0,0,1-5.511,5.511h-8.8a5.511,5.511,0,0,1-5.511-5.511v-8.8a5.511,5.511,0,0,1,5.511-5.511h8.8a5.511,5.511,0,0,1,5.511,5.511Z",
    transform: "translate(-1.4 -1.4)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.ef742bbf73b031d8397a398d5871cf18.svg";
export { ForwardRef as ReactComponent };